import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const CircleLeftIcon = createSvgIcon(
  <>
    <title>circle left</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <circle
        cx="16"
        cy="16"
        fill="none"
        r="15"
        stroke="#222222"
        strokeMiterlimit="10"
      />{' '}
      <polyline
        data-color="color-2"
        fill="none"
        points=" 19,22 13,16 19,10 "
        strokeMiterlimit="10"
      />
    </g>
  </>
)
